import { pick } from 'lodash'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  total: 0,
  items: [],
  full: {}
}

const actions = generateActions('funds/list/GET_TOTAL')
const listActions = generateActions('funds/list/GET_LIST')
const getFullActions = generateActions('funds/list/GET_FULL_INFO')
const fundFormActions=generateActions('funds/fund/PUT_FORM')

export const getTotal = createAction(API_CONST, () => ({
  actions,
  url: 'funds/count'
}))

export const getFund = createAction(API_CONST, fundId => ({
  actions: getFullActions,
  url: `funds/${fundId}`
}))

export const getFunds = createAction(
  API_CONST,
  (part = 0, params = {}) => ({
    params: { limit: 10, ...params, part },
    actions: listActions,
    url: 'funds'
  }),
  (part = 0) => ({ rewrite: !part })
)

export const fundForm = createAction(API_CONST, (data = {}) => ({
  method: 'post',
  noRedirect: true,
  actions: fundFormActions,
  url: `funds/form`,
  params: { ...data },
}))

export const clearList = createAction('funds/list/CLEAR')

//
const reformat = (items = []) => items.map(item => {
  if(item.lotsStats){
    let stats = item.lotsStats[0]
    return {
      ...pick(item, [ '_id', 'alias', 'name' ]),
      sum: stats.bidsSum || null,
      currency: stats.currencySymbol || null
    }
  }
  else{
    return {
      ...pick(item, [ '_id', 'alias', 'name' ]),
      sum: null,
      currency: null
    }
  }
})

export default handleActions({
  [actions[1]]: (state, { payload }) => ({
    ...state,
    total: payload.value || 0
  }),
  [clearList]: state => ({ ...initial }),
  [listActions[0]]: (state, { meta }) => ({
    ...state,
    items: meta.rewrite ? [] : state.items
  }),
  [listActions[1]]: (state, { payload = [] }) => ({
    ...state,
    items: [ ...state.items, ...reformat(payload) ]
  }),
  [getFullActions[1]]: (state, { payload }) => {
	//при наличие alias будет включен в ссылку на лот, если нет остается id
	let alias = payload._id
	if(!payload.withId)
    {
      alias = payload.alias
    }
    return ({
      ...state,
      full: {
        ...state.full,
        ...((payload && payload._id) ? { [alias]: payload } : {})
      }
    })
  }
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/funds/list.js